import React from 'react';

const ICON_ID = 'icon-trash';

const IconTrash = function(props) {
  return (
    <svg viewBox="0 0 15 21" aria-labelledby={ICON_ID}>
      <title id={ICON_ID}>Trash Icon</title>
    <g>
    	<defs>
    		<filter id="Adobe_OpacityMaskFilter" filterUnits="userSpaceOnUse" x="-1" y="-1" width="17" height="23">
    			<feColorMatrix  type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"/>
    		</filter>
    	</defs>
    	<mask maskUnits="userSpaceOnUse" x="-1" y="-1" width="17" height="23" id="mask-2">
    		<g filter="url(#Adobe_OpacityMaskFilter)">
    			<rect id="path-1" x="3" stroke="none" width="9" height="4"/>
    		</g>
    		<g>
    			<rect id="path-3" x="1" y="3" stroke="none" width="13" height="18"/>
    		</g>
    		<g>
    			<rect id="path-5" y="3" stroke="none" width="1" height="1"/>
    		</g>
    		<g>
    			<rect id="path-7" x="14" y="3" stroke="none" width="1" height="1"/>
    		</g>
    		<g>
    			<rect id="path-9" x="4" y="5" stroke="none" width="1" height="14"/>
    		</g>
    		<g>
    			<rect id="path-11" x="7" y="5" stroke="none" width="1" height="14"/>
    		</g>
    		<g>
    			<rect id="path-13" x="10" y="5" stroke="none" width="1" height="14"/>
    		</g>
    	</mask>
    	<g id="icon-_x2F_-trash-_x2F_-no-circle" mask="url(#mask-2)">
    		<g id="Rectangle-4">
    			<rect id="path-1_1_" x="3" fill="none" strokeWidth="2" width="9" height="4"/>
    		</g>
    		<g id="Rectangle-4-Copy">
    			<rect id="path-3_1_" x="1" y="3" fill="none" strokeWidth="2" width="13" height="18"/>
    		</g>
    		<g id="Rectangle-5">
    			<rect id="path-5_1_" y="3" stroke="none" strokeWidth="2" width="1" height="1"/>
    		</g>
    		<g id="Rectangle-5-Copy">
    			<rect id="path-7_1_" x="14" y="3" stroke="none" strokeWidth="2" width="1" height="1"/>
    		</g>
    		<g id="Rectangle-5-Copy-2">
    			<rect id="path-9_1_" x="4" y="5" stroke="none" strokeWidth="2" width="1" height="14"/>
    		</g>
    		<g id="Rectangle-5-Copy-5">
    			<rect id="path-11_1_" x="7" y="5" stroke="none" strokeWidth="2" width="1" height="14"/>
    		</g>
    		<g id="Rectangle-5-Copy-4">
    			<rect id="path-13_1_" x="10" y="5" stroke="none" strokeWidth="2" width="1" height="14"/>
    		</g>
    	</g>
    </g>
    </svg>
  )
}

export default IconTrash;



// WEBPACK FOOTER //
// ./src/client/components/icons/icon-trash.jsx